// extracted by mini-css-extract-plugin
export default {"headerBlock":"Header_headerBlock__61bkA","titleCompany":"Header_titleCompany__xs+HR","btn":"Header_btn__B2xBJ","phone":"Header_phone__BA05v"};